import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";

const LOOKUP_CONFIG = {
  dispenseType: { path: "dispense-type", mutation: "setDispenseType" },
  dispenseBase: { path: "product-base", mutation: "setDispenseBase" },
  UOM: { path: "product-uom", mutation: "setUOM" },
  packaging: { path: "packaging", mutation: "setPackaging" },
};

const fetchProductLookups = async ({ commit }, lookupsType) => {
  const proxy = new GetSimpatraServiceProxy();
  const config = LOOKUP_CONFIG[lookupsType] || LOOKUP_CONFIG.UOM;
  const query = `products/v1/${config.path}`;
  const queryParams = lookupsType === "packaging" ? { deleted: false } : {};
  const additionalConfig =
    lookupsType === "packaging"
      ? {
          notificationParams: {
            errorNotificationMsg: "Unable to load Packaging options. Please try again.",
          },
        }
      : undefined;
  const response = await proxy.execute(query, queryParams, additionalConfig);
  if (response?.data) {
    const { data } = response;
    commit(config.mutation, data);
    return data;
  }
  if (lookupsType === "packaging") {
    commit("setPackaging", []);
  }
  return null;
};

export default {
  fetchProductLookups,
};
